import { jsx as _jsx } from "react/jsx-runtime";
import { Switch } from '@wit-support/ui';
import { FieldShell } from './field-shell.js';
export function BooleanWidget(props) {
    const { field, fieldState, meta, label, description, hint, readonly, disabled } = props;
    return (_jsx(FieldShell, { meta: meta, fieldState: fieldState, label: label, description: description, hint: hint, htmlFor: field.name, children: _jsx(Switch, { id: field.name, name: field.name, checked: Boolean(field.value), onCheckedChange: field.onChange, onBlur: field.onBlur, ref: field.ref, disabled: disabled || (readonly ?? meta.readonly) }) }));
}
//# sourceMappingURL=boolean.js.map